import moment from "moment/moment";

export const formatDate = (date) => {
	const parseDate = new Date(Date.parse(date));
	const stringDate = parseDate.toLocaleDateString();

	return stringDate;
};

export const currentDate = () => {
	let stringDate = '';
	const date = new Date();

	const day = date.getDate();
	const month = date.getMonth() + 1;
	const year = date.getFullYear();

	if (month < 10) {
		stringDate = `${year}-0${month}-${day}`;
	} else {
		stringDate = `${year}-${month}-${day}`;
	}

	return stringDate;
};

export const addMinutesFromCurrentDate = (minutes) => {
	const currentDate = moment();
	const newDate = currentDate.add(minutes, 'minutes');
	const currentNewDate = newDate.format();

	return currentNewDate;
};

export const convertTimeStampToString = (timeStamp) => {
	const date = new Date(timeStamp * 1000);
	const formattedDate = date.toLocaleDateString('es-ES', {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	});
	return formattedDate;
};

export const convertDateToString = (_date) => {
	const date = new Date(_date);
	const formattedDate = date.toLocaleDateString('es-ES', {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	});
	return formattedDate;
};
